<template>
  <svg
    width="50"
    height="50"
    viewBox="0 0 50 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 35.8389H50V41.484C50 45.0485 47.1129 47.9356 43.5484 47.9356H6.45161C2.8871 47.9356 0 45.0485 0 41.484V35.8389Z"
      fill="#E7EEF1"
    />
    <path
      d="M47.5808 34.2259C47.605 33.2985 47.9598 29.7904 45.6534 29.2259C45.4517 28.8468 44.5888 26.9759 43.855 25.3791C43.1775 23.8952 41.6937 22.9355 40.0566 22.9355H33.8711V38.2581H47.2582C47.2582 38.2581 48.3872 37.492 48.3872 36.6452C48.3872 35.7985 48.5888 34.492 47.5808 34.2259Z"
      fill="#6BFFFF"
    />
    <path
      d="M5.64513 6.8064H4.03223"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M2.41954 6.8064H0.806641"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M29.8385 6.80645H21.911C21.5562 6 20.7175 5.33065 19.7497 5.33065C19.4433 5.33065 19.1449 5.37097 18.8788 5.47581C18.3385 4.03226 16.9433 3 15.3062 3C13.2014 3 11.4917 5.20161 11.4917 6.81452H7.25781"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M49.1935 10.8387H46C45.4677 10.0323 44.3629 9.1855 43.0403 9.34679C42.4596 8.35486 41.4032 7.60486 40.1693 7.60486C38.3387 7.60486 36.8548 9.22583 36.8387 10.8387H29.0322"
      stroke="#A2A9B1"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M33.8711 38.2581H47.2582C47.2582 38.2581 48.3872 37.492 48.3872 36.6452C48.3872 35.7985 48.5888 34.492 47.5808 34.2259C47.605 33.2985 47.9598 29.7904 45.6534 29.2259C45.4517 28.8468 44.5888 26.9759 43.855 25.3791C43.1775 23.8952 41.6937 22.9355 40.0566 22.9355H33.8711"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M41.9518 29.3146L40.6292 26.492C40.5324 26.2824 40.3227 26.1533 40.0969 26.1533H37.0889V30.1856H41.3873C41.8389 30.1856 42.1373 29.7178 41.9437 29.3065L41.9518 29.3146Z"
      fill="white"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M33.8707 15.6775H7.25781V38.2581H33.8707V15.6775Z"
      fill="white"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M17.7504 38.2502C17.7504 40.0244 16.3069 41.468 14.5246 41.468C12.7424 41.468 11.2988 40.0244 11.2988 38.2502C11.2988 36.476 12.7424 35.0325 14.5246 35.0325C16.3069 35.0325 17.7504 36.476 17.7504 38.2502Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M42.7504 38.2502C42.7504 40.0244 41.3069 41.468 39.5246 41.468C37.7424 41.468 36.2988 40.0244 36.2988 38.2502C36.2988 36.476 37.7424 35.0325 39.5246 35.0325C41.3069 35.0325 42.7504 36.476 42.7504 38.2502Z"
      fill="#E7EEF1"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M23.3867 26.1614H2.41895V41.484H23.3867V26.1614Z"
      fill="white"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M16.1293 26.1614H9.67773V30.1936H16.1293V26.1614Z"
      fill="#6BFFFF"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M4.83887 38.2581H6.45177"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M8.06445 38.2581H9.67736"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
    <path
      d="M11.29 38.2581H12.9029"
      stroke="#011837"
      stroke-width="1.5"
      stroke-miterlimit="10"
    />
  </svg>
</template>
